import { ChangeDetectionStrategy, Component, Injector } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CcyPairPromiseLookupService } from "shared/cubiq-services";
import { SPINNER_VALUE_ACCESSOR } from "../../bfx-interface-controls/bfx-price-spinner.component";
import { DetailFillRateSpinner } from "./DetailFillRateSpinner";
import { DetailFillSpinnerType } from "./DetailFillSpinnerType";
import { BfxFieldNumberDirective } from "../../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../../shared/base-components/bfx-input";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
} from "../../../shared/base-components/number-spinner.component";

const logger = LoggerService.for(__dirname);

@Component({
  selector: "market-points-spinner",
  templateUrl: "../../../shared/base-components/html/number-spinner.html",
  providers: [SPINNER_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MarketPtsSpinner extends DetailFillRateSpinner {
  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    currencyPairService: CcyPairPromiseLookupService,
  ) {
    super(injector, inputDirective, fieldDirective, currencyPairService);
    this.type = DetailFillSpinnerType.MARKET_PTS;
  }

  getMaxPrecision(pair: CubiqTS.CurrencyPairImpl): number {
    return this.getPointsDigits(pair);
  }
  public override getStep(pair: CubiqTS.CurrencyPairImpl): CubiqTS.BigNumber {
    return this.getPointsStep(pair);
  }

  isCancelBeforeStart?(): boolean {
    return !this.isFwd;
  }

  isCancelAfterEnd?(): boolean {
    return !this.isFwd;
  }

  public onFocus(event: any): void {
    super.onFocus(event);
    event.target.select();
  }
}
